import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

const PORTRAIT =
  "https://images.unsplash.com/photo-1505798577917-a65157d3320a?auto=format&fit=crop&w=900&h=1200&q=80";

export const About = () => {
  const { t } = useLanguage();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 px-6 md:px-12 bg-[#F3F0EA]"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={PORTRAIT}
              alt="Worker at a miter saw cutting trim"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-[#C05C3F] text-white px-6 py-5 hidden md:block max-w-[200px]">
            <p className="text-xs uppercase tracking-[0.2em] font-semibold opacity-80">
              Mont-Royal
            </p>
            <p className="font-display text-lg mt-1 leading-tight">
              Locally owned &amp; operated
            </p>
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <span className="text-[11px] uppercase tracking-[0.25em] font-bold text-[#2A5A3B]">
            {t.about.overline}
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-medium text-[#1C1C1C]">
            {t.about.title}
          </h2>
          <p className="mt-6 text-muted-foreground leading-relaxed">
            {t.about.body1}
          </p>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            {t.about.body2}
          </p>

          <div className="mt-10 grid grid-cols-3 gap-6 border-t border-earth pt-10">
            {t.about.stats.map((stat, i) => (
              <div key={i} data-testid={`about-stat-${i}`}>
                <p className="font-display text-2xl sm:text-3xl font-medium text-[#2A5A3B]">
                  {stat.value}
                </p>
                <p className="mt-2 text-xs uppercase tracking-[0.15em] text-muted-foreground">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
